import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import { useOptionContext } from "../OptionContext/index.js";
import { useElementRef } from "../ElementSync/index.js";

/**
 * Renders its children inside of the container rendered by `FocusedOption`. If `FocusedOption` is
 * not rendered, this component has no effect.
 */
const OnFocusContainer = _ref => {
  let {
    children
  } = _ref;
  const option = useOptionContext();
  const focusedOptionRef = useElementRef('FocusedOption');
  if (!focusedOptionRef.current || !option.isFocused) {
    return null;
  }

  // Wrap in fragment so that react-docgen picks this up as a component
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/ReactDOM.createPortal(children, focusedOptionRef.current));
};
process.env.NODE_ENV !== "production" ? OnFocusContainer.propTypes = {
  /**
   * Contents to render in focus container
   */
  children: PropTypes.node.isRequired
} : void 0;
export default OnFocusContainer;